// import axios from 'axios'
// import store from '../store/index.js'
import {
  request, 
  isJSON, 
  changeStore, 
  getCookie,
  setCookie,
  clearCookie
} from './request.js'

//redEnvelopActivityId  redEnvelopTemplate
let gob = {
  request,
  isJSON,
  changeStore,
  getCookie,
  setCookie,
  clearCookie,
  //事件委托
  getTargetObj: function (classStr, callback) {
    $(document).off('click').on('click', function (ev) {
      var oEvent = ev || event;
      oEvent.cancelBubble = true;
      var targetObj = $(ev.target);
      if (targetObj.attr('class') && targetObj.attr('class').indexOf(classStr) != -1) {
        callback(targetObj);
      }
    });
  },
  isIOS: function () {
    if (/android/i.test(navigator.userAgent)) {
      return 0
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      return 1
    }
  },

  //是否为浮点
  isFloat: function (num) {
    return !(/(^[0-9]*[1-9][0-9]*$)/.test(num));
  },
  getToday:function(){
    return new Date().toLocaleDateString().split("/").join('-');
  },
  getTodayFull:function(time){
    var dataObj=time?new Date(time):new Date();
    return dataObj.toLocaleDateString()+' '+dataObj.getHours()+':'+dataObj.getMinutes()+':'+dataObj.getSeconds()
  },
  parseTime:function(time, cFormat) {
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string')) {
        if ((/^[0-9]+$/.test(time))) {
          time = parseInt(time)
        } else {
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }

      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
      return value.toString().padStart(2, '0')
    })
    return time_str
  },
  escape:function(str) {
    str = str.replace(/&/g, '&amp;')
    str = str.replace(/</g, '&lt;')
    str = str.replace(/>/g, '&gt;')
    str = str.replace(/"/g, '&quto;')
    str = str.replace(/'/g, '&#39;')
    str = str.replace(/`/g, '&#96;')
    str = str.replace(/\//g, '&#x2F;')
    return str
  },
  getQuery(json){
    var b="";
    for(var key in json){
      b+=`&${key}=${json[key]}`
    }
    return b.substring(1);
  },
  //判断小程序环境
  isMiniProgram: function (callback) {
    if (!!navigator.userAgent.toLowerCase().match(/microMessenger/i)) { //微信环境
      wx.miniProgram.getEnv(function (res) {
        callback(true)
      })
    } else { //非微信环境逻辑 `
      callback(false)
    }
  },
  deepClone:(source) =>{
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  },
  drawBg(bgImg,qrCodeImg,callback) {
    let img = new Image()
    img.setAttribute("crossOrigin", "anonymous")
    img.src = bgImg
    img.onload = function() {
        let that = this
        let w = that.width,
            h = that.height,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            attrw = document.createAttribute('width'),
            attrh = document.createAttribute('height')
        attrw.nodeValue = w
        attrh.nodeValue = h
        canvas.setAttributeNode(attrw)
        canvas.setAttributeNode(attrh)
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(that, 0, 0, w, h)
        let poster = canvas.toDataURL('image/jpeg', 1)
        gob.drawQrCode(poster,qrCodeImg,callback)
    }
    
},
  drawQrCode(poster,qrCodeImg,callback) {
    let imgPost = new Image()
    imgPost.src = poster
    imgPost.setAttribute("crossOrigin", "anonymous")
    imgPost.onload = function() {
        let that = this
        let w = that.width,
            h = that.height,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            attrw = document.createAttribute('width'),
            attrh = document.createAttribute('height')
        attrw.nodeValue = w
        attrh.nodeValue = h
        canvas.setAttributeNode(attrw)
        canvas.setAttributeNode(attrh)

        // 绘制海报
        ctx.drawImage(that, 0, 0, canvas.width, h)
        let imgQrCode = new Image()
        imgQrCode.src =  qrCodeImg
        imgQrCode.setAttribute("crossOrigin", "anonymous")
        imgQrCode.onload = function() {
            let _that = this
            ctx.drawImage(_that, 90,h-180,120,120)
            
            // 填充文字
            ctx.font =  "32px Microsoft YaHei"
            ctx.fillStyle = "#333"
            ctx.fillText(`推荐官: ${localStorage.recommendUserName1}`, 90+100+40, h-170+30)

            ctx.font =  "26px Microsoft YaHei"
            ctx.fillStyle = "rgb(17,91,255)"
            ctx.fillText(`( 长按识别办卡 )`, 90+100+40, h-170+30+60)
            if(callback) callback(canvas.toDataURL('image/png', 1))
        }

    }
}
}

export default gob



// WEBPACK FOOTER //
// ./src/utils/index.js